import { z } from 'zod';
export const offerRequestProjectSizeSchema = z.enum([
    'under_5k',
    'from_5k_to_10k',
    'from_10k_to_20k',
    'from_20k_to_50k',
    'over_50k',
]);
export const OfferRequestProjectSize = offerRequestProjectSizeSchema.enum;
export const offerRequestEstimatedVolumeSchema = z.enum([
    'InformationOnly',
    'Below5000',
    'From5000Below10000',
    'From10000Below20000',
    'From20000Below50000',
    'From50000',
]);
export const OfferRequestEstimatedVolume = offerRequestEstimatedVolumeSchema.enum;
const PROJECT_SIZE_BY_ESTIMATED_VOLUME = {
    InformationOnly: undefined,
    Below5000: OfferRequestProjectSize.under_5k,
    From5000Below10000: OfferRequestProjectSize.from_5k_to_10k,
    From10000Below20000: OfferRequestProjectSize.from_10k_to_20k,
    From20000Below50000: OfferRequestProjectSize.from_20k_to_50k,
    From50000: OfferRequestProjectSize.over_50k,
};
export function projectSizeForEstimatedVolume(estimatedVolume) {
    return PROJECT_SIZE_BY_ESTIMATED_VOLUME[estimatedVolume];
}
export function estimatedVolumesForProjectSize(projectSize) {
    return offerRequestEstimatedVolumeSchema.options.filter((estimatedVolume) => PROJECT_SIZE_BY_ESTIMATED_VOLUME[estimatedVolume] === projectSize);
}
